import { toast as rht } from "react-hot-toast";
import type { ToastOptions } from "react-hot-toast";

const options: ToastOptions = {
  duration: 3000,
  position: "top-right",
};


type ToastPromiseParams<T> = {
loading:  string;
success: string | ((data: T) => string);
error: string | ((err: any)=> string);
}

const success = (msg: string) => {
  return rht.success(msg, options);
};

const error = (msg: string) => {
  return rht.error(msg, options);
};

// Custom warning using icon and styles
const warning = (msg: string) => {
  return rht(msg, {
    ...options,
    icon: "⚠️",
    style: {
      background: "#ffffff",
      color: "#92400e",
    },
  });
};

const info = (msg: string) => {
  return rht(msg, {
    ...options,
    icon : "ℹ️",
    style: {
      background: "#4f6bdc", 
      color: "#ffffff",    
      borderRadius: "8px",
      padding: "12px 16px",
      boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
      fontWeight: 500,
    },
  });
};

const promise = <T = any>( myPromise: Promise<T>, msgObj: ToastPromiseParams<T>) => {
  return rht.promise(myPromise, msgObj, options);
};

const toast = {
  success,
  error,
  warning,
  info,
  promise,
};

export default toast;
